
import multiSceneGetActions from './multiscene';

export * from './multiscene';

export function getActions(dispatch) {
    return {
        ...multiSceneGetActions(dispatch)
    }
}
